"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeIncorrectFilters = exports.assertReportFilter = exports.assertUpdateReportDefinition = exports.isSinglePointInTimeReport = exports.isGroupByDate = exports.statHasDate = void 0;
var constants_1 = require("./constants");
var schemas_1 = require("./schemas");
var insights_1 = require("../../insights");
var luxon_1 = require("luxon");
var dates_1 = require("../../dates");
function statHasDate(stat) {
    return constants_1.cStatisticTypeHasDate[stat];
}
exports.statHasDate = statHasDate;
function isGroupByDate(groupByValue) {
    return constants_1.cGroupByDateOpts.includes(groupByValue);
}
exports.isGroupByDate = isGroupByDate;
function isSinglePointInTimeReport(data) {
    return (data === null || data === void 0 ? void 0 : data.count) !== undefined;
}
exports.isSinglePointInTimeReport = isSinglePointInTimeReport;
// this is most useful for the API to make sure it's
// actually receiving what we think it is
function assertUpdateReportDefinition(validatee) {
    try {
        // this throws if validation fails
        var reportDef = schemas_1.cUpdateReportDefinitionZodObj.parse(validatee);
        assertNoHardCodedAndCustomisableStats(reportDef);
        assertDateGroupOfReport(reportDef);
        return true;
    }
    catch (err) {
        return err;
    }
}
exports.assertUpdateReportDefinition = assertUpdateReportDefinition;
/**
 * Can't use hard coded stats and customisable
 * ones together in the same report.
 */
function assertNoHardCodedAndCustomisableStats(reportDef) {
    var statNames = reportDef.opts.stats.map(function (stat) { return stat.statName; });
    var usingHardCodedStats = statNames.some(function (stat) {
        return insights_1.hardCodedStatistics.includes(stat);
    });
    // using hard coded stats
    if (!usingHardCodedStats) {
        return;
    }
    var isUsingCustomisableStats = statNames.some(function (stat) {
        return insights_1.customisableStatistics.includes(stat);
    });
    if (isUsingCustomisableStats) {
        throw new Error('A report cannot combine hard coded and customisable statistics.');
    }
    // There can be only one
    if (statNames.length > 1) {
        throw new Error('A report can only contain 1 hard coded statistic.');
    }
}
function assertDateGroupOfReport(reportDef) {
    if (reportDef.opts.groupBy.groupByKey !== 'date') {
        return;
    }
    var statistics = reportDef.opts.stats.map(function (stat) { return stat.statName; });
    var availableDateGroupsForStats = (0, insights_1.getAvailableDateGroupsForStats)({
        statistics: statistics
    });
    var dateGroup = reportDef.opts.groupBy.groupByValue;
    if (!availableDateGroupsForStats.includes(dateGroup)) {
        throw new Error("The date group ".concat(dateGroup, " is not available for the selected statistics. Selected stats: ").concat(JSON.stringify(statistics), ". Available date groups: ").concat(JSON.stringify(availableDateGroupsForStats)));
    }
}
function getFixedRangeFilterErrors(reportFilter) {
    var _a;
    var errors = [];
    if (((_a = reportFilter.date) === null || _a === void 0 ? void 0 : _a.operator) !== 'fixedRange') {
        return [];
    }
    if (!reportFilter.date.from && !reportFilter.date.to) {
        errors.push('missingFixedRangeDate');
    }
    if (!reportFilter.date.from && reportFilter.date.to) {
        errors.push('missingStartFixedRangeStartDate');
    }
    if (!reportFilter.date.to && reportFilter.date.from) {
        errors.push('missingStartFixedRangeEndDate');
    }
    var from = luxon_1.DateTime.fromFormat(reportFilter.date.from, 'yyyy-MM-dd');
    var to = luxon_1.DateTime.fromFormat(reportFilter.date.from, 'yyyy-MM-dd');
    if ((0, dates_1.dateIsBefore)({
        date: from,
        isBefore: to
    })) {
        errors.push('fromDateAfterToDate');
    }
    if ((0, dates_1.dateIsAfter)({
        date: to,
        isAfter: from
    })) {
        errors.push('toDateBeforeFromDate');
    }
    return errors;
}
function assertReportFilter(reportFilter) {
    var errors = [];
    errors.push.apply(errors, getFixedRangeFilterErrors(reportFilter));
    if (errors.length) {
        return {
            valid: false,
            errors: errors
        };
    }
    return {
        valid: true
    };
}
exports.assertReportFilter = assertReportFilter;
/**
 * Asserts each individual filter and removes incorrect ones.
 * @param reportFilter
 * @returns
 */
function removeIncorrectFilters(reportFilter) {
    // The filter object looks something like
    // { date: {}, user: {} } etc.
    // We'll iterate over each key (i.e. date, user, etc.) and remove incorrect
    // filters.
    var cleanedUpFilters = {};
    var errors = [];
    Object.keys(reportFilter).forEach(function (_filterKey) {
        var _a;
        var filterKey = _filterKey;
        var individualFilter = (_a = {},
            _a[filterKey] = reportFilter[filterKey],
            _a);
        var filterCheck = assertReportFilter(individualFilter);
        if (filterCheck.valid === false) {
            errors.push.apply(errors, filterCheck.errors);
            return;
        }
        // @ts-expect-error I don't know how to fix this and
        // I'm 99% sure it's fine
        cleanedUpFilters[filterKey] = reportFilter[filterKey];
    });
    return {
        reportFilters: cleanedUpFilters,
        errors: errors
    };
}
exports.removeIncorrectFilters = removeIncorrectFilters;
